import { render, staticRenderFns } from "./RuleGroupDetails.vue?vue&type=template&id=2c3f9516&"
import script from "./RuleGroupDetails.vue?vue&type=script&lang=js&"
export * from "./RuleGroupDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports